module.exports = __webpack_public_path__ + "img/mezcla_para_construir.7061017a.png";